module.exports = __webpack_public_path__ + "img/bgc18.71828002.png";